import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4273428b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4273428b",
  null
  
)

export default component.exports